(()=>{
  if(window.AWSearchIntents?.version)return;
  const allowed=new Set(['all','products','compatibility','guides','atelier']);
  const normPath=(href='')=>{try{return new URL(href,location.href).pathname.slice(0,180)}catch(_){return''}};
  const track=(name,data={})=>{try{window.AWAnalytics?.track?.(name,{ranking_mode:'observe_only',ranking_surface:'search_results',...data})}catch(_){}};
  const resultType=(item)=>{
    const href=item.querySelector('a[href]')?.getAttribute('href')||'';
    const path=normPath(href);
    if(path.startsWith('/products/'))return'product';
    if(path.startsWith('/collections/'))return'collection';
    if(path.startsWith('/blogs/'))return'article';
    if(path.startsWith('/pages/'))return'page';
    return item.dataset.awSearchIntent||'other';
  };
  const init=(scope=document)=>scope.querySelectorAll('[data-aw-search-intents]').forEach(root=>{
    if(root.dataset.awReady==='true')return;
    const grid=root.parentElement?.querySelector('[data-aw-search-results-grid]');
    if(!grid)return;
    let currentResults=[...grid.querySelectorAll('[data-aw-search-result]')];
    const results=()=>currentResults;
    const refreshResults=()=>{currentResults=[...grid.querySelectorAll('[data-aw-search-result]')]};
    const buttons=[...root.querySelectorAll('[data-aw-search-intent-button]')];
    const status=root.querySelector('[data-aw-search-intent-status]');
    const empty=root.parentElement?.querySelector('[data-aw-search-intent-empty]');
    const form=document.querySelector('[data-aw-search-form]');
    const url=new URL(location.href);
    const term=root.dataset.searchTerm||'';
    let active=allowed.has(url.searchParams.get('aw_intent'))?url.searchParams.get('aw_intent'):'all';
    let lastSnapshot='';
    const syncForm=()=>{
      if(!form)return;
      let hidden=form.querySelector('input[name="aw_intent"]');
      if(active==='all'){hidden?.remove();return}
      if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name='aw_intent';form.appendChild(hidden)}
      hidden.value=active;
    };
    const visibleResults=()=>results().filter(item=>!item.hidden);
    const snapshot=(reason)=>{
      const current=results();
      const visible=current.filter(item=>!item.hidden);
      const top=visible.slice(0,12);
      const signature=`${active}|${top.map(item=>current.indexOf(item)+1+':'+normPath(item.querySelector('a[href]')?.getAttribute('href')||'')).join('|')}`;
      if(signature===lastSnapshot)return;
      lastSnapshot=signature;
      track('search_rank_snapshot',{
        snapshot_reason:reason,
        term,
        active_intent:active,
        results_on_page:current.length,
        visible_count:visible.length,
        ranked_overall_positions:top.map(item=>current.indexOf(item)+1),
        ranked_types:top.map(resultType),
        ranked_intents:top.map(item=>item.dataset.awSearchIntent||'other'),
        ranked_targets:top.map(item=>normPath(item.querySelector('a[href]')?.getAttribute('href')||''))
      });
    };
    const apply=(shouldTrack=false)=>{
      const current=results();
      let visible=0;
      current.forEach(item=>{const show=active==='all'||item.dataset.awSearchIntent===active;item.hidden=!show;if(show)visible+=1});
      buttons.forEach(btn=>{const on=btn.dataset.awSearchIntentButton===active;btn.setAttribute('aria-pressed',on?'true':'false');btn.classList.toggle('is-active',on)});
      if(status)status.textContent=`${visible} résultat${visible>1?'s':''} affiché${visible>1?'s':''} sur cette page`;
      if(empty)empty.hidden=visible!==0;
      syncForm();
      if(shouldTrack)track('search_intent_selected',{intent:active,term,visible_on_page:visible,universe:document.documentElement.dataset.awUniverse||'',platform:document.documentElement.dataset.awPlatform||''});
      snapshot(shouldTrack?'intent_change':'initial');
    };
    buttons.forEach(btn=>btn.addEventListener('click',()=>{
      const next=btn.dataset.awSearchIntentButton;
      if(!allowed.has(next)||next===active)return;
      active=next;
      const nextUrl=new URL(location.href);
      if(active==='all')nextUrl.searchParams.delete('aw_intent');else nextUrl.searchParams.set('aw_intent',active);
      history.replaceState({},'',nextUrl);
      apply(true);
    }));
    grid.addEventListener('click',event=>{
      const item=event.target.closest('[data-aw-search-result]');
      const link=event.target.closest('a[href]');
      if(!item||!link)return;
      const current=results();
      const visible=visibleResults();
      track('search_result_clicked',{
        term,
        active_intent:active,
        result_intent:item.dataset.awSearchIntent||'other',
        result_type:resultType(item),
        rank_overall:current.indexOf(item)+1,
        rank_visible:visible.indexOf(item)+1,
        target_path:normPath(link.getAttribute('href')||'')
      });
    },true);
    grid.addEventListener('aw:search-results-mutated',()=>{refreshResults();apply(false)});
    root.dataset.awReady='true';
    apply(false);
    track('search_intent_viewed',{intent:active,term,results_on_page:results().length,universe:document.documentElement.dataset.awUniverse||'',platform:document.documentElement.dataset.awPlatform||''});
  });
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
  window.AWSearchIntents={version:'1.2.2',mode:'observe_only-cached-results',init};
  const current=document.currentScript;
  if(document.querySelector('[data-aw-natural-server-grid="true"]')) return;
  if(current?.src&&!window.AWSearchModelRecall?.version&&!document.querySelector('script[data-aw-search-model-recall]')){
    try{
      const loader=document.createElement('script');
      const recallUrl=new URL('aw-search-model-recall.js',current.src);
      recallUrl.search='';
      recallUrl.searchParams.set('aw_v','da955bbf4391380cb42fca59cde1432c');
      loader.src=recallUrl.href;
      loader.async=true;
      loader.dataset.awSearchModelRecall='true';
      document.head.appendChild(loader);
    }catch(_){}
  }
})();

(()=>{
  if(window.AWSearchProof?.version)return;
  const norm=(value='')=>String(value??'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('fr-FR').replace(/[’']/g,' ').replace(/[^a-z0-9]+/g,' ').trim();
  const compact=(value='')=>norm(value).replace(/\s+/g,'');
  const split=(value='')=>String(value||'').split('|').map(norm).filter(Boolean);
  const params=new URLSearchParams(location.search);
  const term=(params.get('q')||'').trim();
  const termNorm=norm(term);
  const termCompact=compact(term);
  if(!termNorm)return;

  const classify=(item)=>{
    const skus=split(item.dataset.awSearchSkus);
    if(termCompact&&skus.some(value=>compact(value)===termCompact))return{label:'Référence exacte',type:'reference'};
    const models=split(item.dataset.awSearchModels);
    if(termCompact&&models.some(value=>value===termNorm||compact(value)===termCompact))return{label:'Modèle référencé',type:'model'};
    const title=norm(item.dataset.awSearchTitle||'');
    if(title&&title===termNorm)return{label:'Correspondance exacte',type:'title'};
    return null;
  };

  const ensureStyles=()=>{
    if(document.getElementById('AWSearchProofStyles'))return;
    const style=document.createElement('style');
    style.id='AWSearchProofStyles';
    style.textContent='.aw-search-proof{display:inline-flex;width:max-content;max-width:100%;margin:0 0 7px;padding:5px 8px;border:1px solid rgba(196,38,38,.58);background:rgba(196,38,38,.08);color:#ff9a9a;font-size:9px;font-weight:900;line-height:1.2;letter-spacing:.075em;text-transform:uppercase}.aw-search-ranking-note{margin:0 0 16px;padding:10px 12px;border-left:2px solid #b91111;background:#0b0b0b;color:#9f9f9f;font-size:11px;line-height:1.5}.aw-search-ranking-note strong{color:#eee}@media(max-width:749px){.aw-search-proof{font-size:8px}.aw-search-ranking-note{margin-bottom:12px}}';
    document.head.appendChild(style);
  };

  const applyItem=(item)=>{
    if(!item||item.dataset.awSearchProofApplied==='true')return;
    item.dataset.awSearchProofApplied='true';
    const proof=classify(item);
    if(!proof)return;
    const card=item.querySelector('[data-aw-product-card]')||item;
    const title=card.querySelector('.product-card-v3__title');
    if(!title)return;
    const badge=document.createElement('span');
    badge.className='aw-search-proof';
    badge.dataset.awSearchProof=proof.type;
    badge.textContent=proof.label;
    title.before(badge);
    item.dataset.awSearchProof=proof.type;
  };

  const ensureNote=(grid)=>{
    if(!grid||document.querySelector('[data-aw-search-ranking-note]'))return;
    const note=document.createElement('p');
    note.className='aw-search-ranking-note';
    note.dataset.awSearchRankingNote='true';
    note.innerHTML='<strong>Classement AW :</strong> les références et modèles exacts passent en premier ; à pertinence comparable, les produits disponibles sont prioritaires.';
    grid.before(note);
  };

  const apply=()=>{
    ensureStyles();
    const grid=document.querySelector('[data-aw-search-results-grid]');
    if(!grid)return;
    ensureNote(grid);
    grid.querySelectorAll('[data-aw-search-product]').forEach(applyItem);
    if(grid.dataset.awSearchProofObserved==='true')return;
    grid.dataset.awSearchProofObserved='true';
    new MutationObserver(()=>grid.querySelectorAll('[data-aw-search-product]').forEach(applyItem)).observe(grid,{childList:true,subtree:true});
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});else queueMicrotask(apply);
  window.AWSearchProof={version:'1.0.1',mode:'proof-only-inline',analytics:'disabled',apply};
})();

(()=>{
  if(window.AWSearchReferenceProof?.version)return;
  const norm=(value='')=>String(value??'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('fr-FR').replace(/[’']/g,' ').replace(/[^a-z0-9]+/g,' ').trim();
  const params=new URLSearchParams(location.search);
  const term=norm(params.get('q')||'');
  if(!term||term.length<3)return;
  const exactRefInTitle=(title)=>{
    const hay=norm(title);
    const padded=` ${hay} `;
    return [` ref ${term} `,` reference ${term} `].some(needle=>padded.includes(needle));
  };
  const applyItem=(item)=>{
    if(!item||item.querySelector('.aw-search-proof'))return;
    if(!exactRefInTitle(item.dataset.awSearchTitle||''))return;
    const title=item.querySelector('.product-card-v3__title');
    if(!title)return;
    const badge=document.createElement('span');
    badge.className='aw-search-proof';
    badge.dataset.awSearchProof='reference-title';
    badge.textContent='Référence exacte';
    title.before(badge);
    item.dataset.awSearchProof='reference-title';
  };
  const apply=()=>{
    const grid=document.querySelector('[data-aw-search-results-grid]');
    if(!grid)return;
    grid.querySelectorAll('[data-aw-search-product]').forEach(applyItem);
    if(grid.dataset.awSearchReferenceProofObserved==='true')return;
    grid.dataset.awSearchReferenceProofObserved='true';
    new MutationObserver(()=>grid.querySelectorAll('[data-aw-search-product]').forEach(applyItem)).observe(grid,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});else queueMicrotask(apply);
  window.AWSearchReferenceProof={version:'1.0.0',mode:'explicit-ref-title-only',analytics:'disabled',apply};
})();
